module.exports = __webpack_public_path__ + "static/media/n-create-active.d140b6c7.svg";